var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHmleftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7288 0.239639C11.0539 0.559112 11.054 1.07718 10.7287 1.39671L2.99115 8.99981L10.7288 16.6033C11.0539 16.9228 11.054 17.4408 10.7287 17.7604C10.4036 18.0799 9.8764 18.0799 9.55123 17.7604L1.22484 9.57832C1.06869 9.42488 0.980989 9.21679 0.980989 8.99981C0.980989 8.78282 1.06875 8.57468 1.2249 8.4213L9.55129 0.239694C9.8764 -0.0798881 10.4036 -0.0798884 10.7288 0.239639Z",
    fill: "#3A6EED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmleftArrow);
export default __webpack_public_path__ + "static/media/hmleft_arrow.9fda7c3cb220857709719b1ef25b1ac4.svg";
export { ForwardRef as ReactComponent };